var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ErrorCode, handleXHRError, SDKError } from '../../ErrorModule';
export function xhrProgressRequest({ method, url, headers, params, body, onProgress, signal, }) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const requestAbortedError = new DOMException('Request aborted', 'AbortError');
            if (signal && signal.aborted) {
                reject(requestAbortedError);
                return;
            }
            const xhr = new XMLHttpRequest();
            if (params) {
                xhr.open(method.toUpperCase(), `${url.toString()}?${params}`, true);
            }
            else {
                xhr.open(method.toUpperCase(), url.toString(), true);
            }
            if (onProgress && typeof onProgress === 'function') {
                const handleProgress = (progressEvent) => onProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
                // msw doesn't support xhr.upload.addEventListener yet, and throws when it's used
                if (typeof xhr.upload.addEventListener === 'function') {
                    xhr.upload.addEventListener('progress', handleProgress, { signal: signal !== null && signal !== void 0 ? signal : undefined });
                }
                else {
                    xhr.upload.onprogress = handleProgress;
                }
            }
            function abort() {
                xhr.abort();
            }
            if (signal) {
                signal.addEventListener('abort', abort, { once: true });
            }
            headers === null || headers === void 0 ? void 0 : headers.forEach((value, key) => xhr.setRequestHeader(key, value));
            xhr.onload = () => resolve(xhr);
            xhr.onabort = () => reject(requestAbortedError);
            xhr.onerror = () => {
                handleXHRError(xhr, reject);
            };
            xhr.ontimeout = () => reject(new SDKError(ErrorCode.GatewayTimeout));
            xhr.send(body);
        });
    });
}
//# sourceMappingURL=xhrProgressRequest.js.map